import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FaGoogle, FaMicrosoft } from 'react-icons/fa';
import useCalendarsSyncSection from './useCalendarSyncSection';

interface ICalendarSyncSectionProps {}

export default function CalendarSyncSection(props: ICalendarSyncSectionProps) {
	const { t } = useTranslation();
	const { handleSyncGoogle, handleSyncMicrosoft } = useCalendarsSyncSection();

	return (
		<Box>
			<Text flex="1" px="3" mt="4" pb="3">
				{t('Sync another calendar')}
			</Text>

			<HStack mx="3">
				<Button
					textAlign="center"
					size="xs"
					colorScheme="blue"
					variant="outline"
					type="button"
					onClick={handleSyncGoogle}
					leftIcon={<FaGoogle />}
				>
					{t('Google')}
				</Button>

				<Button
					textAlign="center"
					mt="2"
					size="xs"
					colorScheme="blue"
					variant="outline"
					type="button"
					onClick={handleSyncMicrosoft}
					leftIcon={<FaMicrosoft />}
				>
					{t('Microsoft')}
				</Button>
			</HStack>
		</Box>
	);
}
